function initUspCarouselMobile() {
  const carousels = document.querySelectorAll('usp-carousel-mobile-component');
  
  carousels.forEach((carousel) => {
    const track = carousel.querySelector('.usp-carousel-mobile__track');
    const items = carousel.querySelectorAll('.usp-carousel-mobile__item');
    
    if (!track || items.length <= 1) return;
    
    let currentIndex = 0;
    const itemCount = items.length;
    const scrollInterval = parseInt(carousel.dataset.scrollInterval || '2000', 10);
    let isPaused = false;
    let autoScrollTimer = null;
    
    // Check if user prefers reduced motion
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      return; // Don't auto-scroll if user prefers reduced motion
    }
    
    function goToSlide(index) {
      currentIndex = index;
      track.style.transform = `translateX(-${index * 100}%)`;
    }
    
    function next() {
      const newIndex = (currentIndex + 1) % itemCount;
      goToSlide(newIndex);
    }
    
    function startAutoScroll() {
      stopAutoScroll();
      if (isPaused) return;
      
      autoScrollTimer = setInterval(() => {
        next();
      }, scrollInterval);
    }
    
    function stopAutoScroll() {
      if (autoScrollTimer) {
        clearInterval(autoScrollTimer);
        autoScrollTimer = null;
      }
    }
    
    function pause() {
      isPaused = true;
      stopAutoScroll();
    }
    
    function resume() {
      isPaused = false;
      startAutoScroll();
    }
    
    // Pause on hover/touch
    carousel.addEventListener('pointerenter', pause);
    carousel.addEventListener('pointerleave', resume);
    
    // Start auto-scroll
    startAutoScroll();
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initUspCarouselMobile);
} else {
  initUspCarouselMobile();
}

